export default {
    install(app) {
        app.config.globalProperties.$helper = this
    },
    priceFormatter(price, toman = true) {
        try {
            let formattedPrice =
                price
                    .toFixed(0)
                    .replace(new RegExp('\\d(?=(\\d{3})+$)', 'g'), '$&,');

            if (toman) {
                return formattedPrice + " تومان "
            }

            return formattedPrice
        } catch (e) {
            return 0 + " تومان"
        }
    },
}